import { Injectable } from '@angular/core';
import { Router, UrlTree, GuardResult } from '@angular/router';
import {
  AuthService,
  CmsService,
  PageType,
  ProtectedRoutesService,
  SemanticPathService,
  UserIdService
} from '@spartacus/core';
import { AsmComponentService } from '@spartacus/asm/components';
import { from, Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomLogoutGuard {

  constructor(
    protected auth: AuthService,
    protected cms: CmsService,
    protected semanticPathService: SemanticPathService,
    protected protectedRoutes: ProtectedRoutesService,
    protected router: Router,
    protected userIdService: UserIdService,
    protected asmComponentService: AsmComponentService
  ) { }

  canActivate(): Observable<GuardResult> {
    return from(this.logout()).pipe(
      switchMap(() => {
        return this.cms
          .hasPage({
            id: this.semanticPathService.get('logout') ?? '',
            type: PageType.CONTENT_PAGE,
          })
          .pipe(
            map((hasPage) => {
              if (!hasPage) {
                return this.getRedirectUrl();
              }
              return hasPage;
            })
          );
      })
    );
  }

  protected logout(): Promise<any> {
    return new Promise((resolve) => {
      this.userIdService.isEmulated().pipe(take(1)).subscribe(isEmulated => {
        if (isEmulated) {
          this.asmComponentService.logoutCustomer();
          this.userIdService.setUserId('anonymous');
          this.router.navigateByUrl('/');
          resolve(true);
        } else {
          this.auth.coreLogout().then(resolve);
        }
      });

    });
  }

  protected getRedirectUrl(): UrlTree {
    const cxRoute = this.protectedRoutes.shouldProtect ? 'login' : 'home';
    return this.router.parseUrl(this.semanticPathService.get(cxRoute) ?? '');
  }
}